import { ElementType } from 'react';

import {
  FILE_ICON_CHAT_COMPONENTS_MAP,
  FILE_ICON_DEFAULT_COMPONENTS_MAP,
} from './FileIcon.constants';
import {
  FileIconState,
  FileIconType,
  mapFileIconThemeByFileExt,
  TFileTheme,
} from './FileIcon.types';

export const getFileIconThemeByExt = (ext: string): TFileTheme => {
  const theme = mapFileIconThemeByFileExt[ext];

  if (!theme) {
    return '130';
  }

  return theme;
};

export const getFileIconComponent = (
  type: FileIconType = FileIconType.Default,
  state?: FileIconState
): ElementType => {
  if (type === FileIconType.Default) {
    return FILE_ICON_DEFAULT_COMPONENTS_MAP[state || FileIconState.Regular];
  } else {
    return FILE_ICON_CHAT_COMPONENTS_MAP[state || FileIconState.Regular];
  }
};
